module.exports = __webpack_public_path__ + "static/media/Sayan2.0add44f2.jpg";